import Vue from 'vue'
import Router from 'vue-router'
import CaseBlock from '@/components/CaseBlock'
import HomePage from '@/components/HomePage'
import VueScrollTo from 'vue-scrollto'

Vue.use(Router);

export default new Router({

  base: '/',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/project/:id',
      name: 'project',
      component: CaseBlock,
      props: true
    },
    {
      path: '/:lang',
      name: 'HomePageByLang',
      component: HomePage
    },
    {
      path: '/:lang/project/:id',
      name: 'projectByLang',
      component: CaseBlock,
      props: true
    },
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      VueScrollTo.scrollTo(to.hash, 1200);
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0}
    }
  }
})


// WEBPACK FOOTER //
// ./src/router/index.js